import React, { Component } from 'react';
import { MDBIcon, MDBInput } from 'mdbreact';
import { ReportePorVacanteHojaVida, TrabajeconNosotros_, ArchivoPDF } from '../../../services/WebAPI_Utrahuilca'
import Swal from 'sweetalert2';
import Loading from '../../../components/Loading';
import Select from 'react-select'
import { getCustomSelectStyles } from '../../../utils/selectStyles';

class ReporteSolicitudVacantes extends Component {
    constructor(props) {
        super(props);
        this.initialState = {
            vacantes: [],
            errors: {},
            selectedIdVacante: null,
            stateLoadign: false,
            fecInicioPostulacion: '',
            fecFinPostulacion: '',
            estadoNoVacantes: false,
            result: []
        };
        this.state = this.initialState;
    }

    validateForm = () => {
        const errors = {};
        const { selectedIdVacante, fecInicioPostulacion, fecFinPostulacion } = this.state;

        if (!selectedIdVacante) {
            errors.selectedIdVacante = "Debes seleccionar una vacante";
        }

        if (!fecInicioPostulacion) {
            errors.fecInicioPostulacion = "Ingresa la fecha de inicio de postulación";
        }

        if (!fecFinPostulacion) {
            errors.fecFinPostulacion = "Tienes que seleccionar una fecha de fin";
        }

        if (fecInicioPostulacion && fecFinPostulacion) {
            const inicio = new Date(fecInicioPostulacion + "T00:00:00");
            const fin = new Date(fecFinPostulacion + "T00:00:00");
            const diffTime = fin.getTime() - inicio.getTime();
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (fin < inicio) {
                errors.fecFinPostulacion = "La fecha de finalización no puede ser antes de la de inicio";
            } else if (diffDays === 0) {
                errors.fecFinPostulacion = "La fecha de fin no puede ser el mismo día que la de inicio";
            } else if (diffDays < 1) {
                errors.fecFinPostulacion = "La fecha de fin debe ser al menos un día después de la de inicio";
            }
        }

        return errors;
    };


    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    async componentDidMount() {
        const data = {
            tran: 7,
            idvacante: 0,
            nombcargo: 'NA',
            descperfil: 'NA',
            rutaimgvacant: 'NA',
            desccargo: 'NA',
            estado: 1,
            usucrea: 'NA'
        };

        try {
            const response = await TrabajeconNosotros_(data);
            if (response.data.length > 0) {
                this.setState({
                    estadoNoVacantes: response.data[0].message === "004404",
                    vacantes: response.data.map(v => ({
                        value: v.idvacante,
                        label: v.nombcargo
                    }))
                }, () => {
                    console.log("Ofertas: ", this.state.vacantes);
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un error!'
                });
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Ocurrió un error cargando las ofertas!'
            });
        }

    }

    //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026
    fetchPostulados = () => {
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE AGREGA EL TRAN COMO VARIABLE PARA QUE LO RECIVA EL CLS
        const data = {
            tran: 2,
            idvacante: this.state.selectedIdVacante,
            fecin: this.state.fecInicioPostulacion,
            fecfin: this.state.fecFinPostulacion
        }

        //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE AGREGA PARA QUE SE MUESTRE EL LOADING MIENTRAS SE CONSULTA
        this.setState({
            stateLoadign: true
        })

        //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE MODIFICA POR COMPLETO PARA QUE AHORA RECIBA UN DATATABLE Y CAMBIEN EL STATELOADING
        ReportePorVacanteHojaVida(data).then(result => {
            //const url = window.URL.createObjectURL(new Blob([result.data])); //Enlace temporal para la descarga del archivo
            //const link = document.createElement("a");
            //link.href = url;
            //link.setAttribute("download", "ReporteVacantes.xls");
            //document.body.appendChild(link);
            ////Simulación del click
            //link.click();
            //link.remove();
            //Swal.fire({ icon: 'success', title: 'Completado', text: 'Se generó exitosamente el reporte.' });
            //this.setState({ errors: {} });
            console.log(result);
            this.setState({ result: result.data, stateLoadign: false });
        }).catch(err => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo generar las vacantes.' });
            this.setState({ stateLoadign: false });
        })
    }

    //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026
    hojadevida = (idsolicitud) => {
        //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE AGREGA METODO NUEVO PARA CONSULTAR INFORMACION ESPESIFICA DEL PROSPECTO
        try {
            //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE CREA EL DATA PARA HACER LA CONSULTA DEL PROSPECTO
            const data = {
                tran: 1,
                idsolicitudvacante: idsolicitud
            };
            //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE ENVIA LOS PARAMETROS DE CONSULTA, SE RECIBE Y SE APERTURA UN VENTANA Y CON LA INFORMACION ENTREGADA 
            ArchivoPDF(data).then(result => {
                const url = window.open("", "_blank");
                url.document.open()
                url.document.write(result.data)
                url.document.close();
            });
        }
        catch {
            Swal.fire({
                icon: 'error',
                title: 'Ocurrió un error cargando las ofertas!'
            });
        }
    }

    //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026
    limpiarDatos = () => {
        //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE ELIMINA QUE VUELVA AL ESTADO INICIAL, YA QUE ESO VACIABA LOS VACANTES DISPONIBLES, ASI QUE SE CREA UN NUEVO ESTADO, QUITANDO EL VACANTE[] PARA QUE NO SE PIERDA LA INFO
        this.setState({
            errors: {},
            selectedIdVacante: null,
            stateLoadign: false,
            fecInicioPostulacion: '',
            fecFinPostulacion: '',
            estadoNoVacantes: false,
            result: []
        });
    }

    //MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026
    render() {
        const { selectedIdVacante, vacantes, errors, fecInicioPostulacion, fecFinPostulacion, result } = this.state;
        return (
            <React.Fragment>
                <p className="font-weight-bold">Reporte de Solicitudes para Vacantes</p>
                <hr />
                <React.Fragment>
                    <div className="container mt-5 pt-5 pb-5">
                        <div className="row">
                            <div className="col-md-4">
                                <label style={{ marginBottom: '2px' }}>Nombre de la Vacante</label>
                                <Select
                                    name="selectedIdVacante"
                                    className="react-select-container"
                                    options={vacantes}
                                    styles={getCustomSelectStyles()}
                                    value={vacantes.find(opt => opt.value === selectedIdVacante) || null}
                                    onChange={selected => this.setState({ selectedIdVacante: selected ? selected.value : null })}
                                    placeholder="Seleccione una vacante…"
                                    isClearable
                                >
                                </Select>
                                {errors.selectedIdVacante && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.selectedIdVacante}</strong>}
                            </div>
                            <div className="col-md-4">
                                <label style={{ marginBottom: '2px' }}>Fecha de Incio de Postulación</label>
                                <MDBInput
                                    name="fecInicioPostulacion"
                                    type="date"
                                    className="text-postulate date-selector"
                                    value={fecInicioPostulacion}
                                    onChange={this.textInput}
                                />
                                {errors.fecInicioPostulacion && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.fecInicioPostulacion}</strong>}
                            </div>
                            <div className="col-md-4">
                                <label style={{ marginBottom: '2px' }}>Fecha de Finalización</label>
                                <MDBInput
                                    name="fecFinPostulacion"
                                    type="date"
                                    className="text-postulate date-selector"
                                    value={fecFinPostulacion}
                                    onChange={this.textInput}
                                />
                                {errors.fecFinPostulacion && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '75px' }}>{errors.fecFinPostulacion}</strong>}
                            </div>
                            <div className="col-md-12 mt-3 d-flex justify-content-center gap-2">
                                <button type="button" className="btn btn-success px-3" onClick={this.fetchPostulados}>Generar &nbsp; <MDBIcon icon="file-alt xs" /></button>
                                <button type="button" className="btn btn-warning px-3" onClick={this.limpiarDatos}>Limpiar &nbsp; <MDBIcon icon="trash-alt xs" /></button>
                            </div>
                            {/*MC - REPORT. PROSPECTOS, JUAN MELENDEZ 2026 SE AGREGA A LA VISTA LA TABLA DE LOS PROSPECTOS CON INFORMACION RELEVANTE*/}
                            <div>
                                <table style={{ width: "1145px", borderRadius: "15px", marginTop: "20px", overflow: "hidden" }}>
                                    <thead style={{ background: "#F47216", color: "white" }}>
                                        <tr>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>TIPO ID</th>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>CEDULA</th>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>NOMBRE</th>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>NIVEL ACADEMICO</th>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>RESIDENCIA</th>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>EDAD</th>
                                            <th style={{ padding: "10px", border: "1px solid #ddd" }}>H.V</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    {
                                        result?.length > 0 &&
                                        result[0].descMessage
                                        ?
                                        <tr>
                                            <td
                                                colSpan="100"

                                                style={{
                                                    textAlign: "center",
                                                    padding: "15px",
                                                    backgroundColor: "#FFF3E0",
                                                    color: "#856404",
                                                    border: "1px solid #ddd",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                {result[0].descMessage}
                                            </td>
                                        </tr>
                                        : result?.map((objeto, lista) => (
                                            <tr key={lista} style={{ background: lista % 2 === 0 ? "#FFF3E0" : "#FFE0B2" }}>
                                                {Object.keys(objeto).filter(columna => columna !== "idsolicitud").map((columna) => (
                                                    <td style={{ padding: "8px", border: "1px solid #ddd" }} key={columna}>{objeto[columna]}</td>
                                                ))}
                                                <td style={{ border: "1px solid #ddd", textAlign: "center" }} >
                                                    <button className="btn btn-success px-3" style={{ borderRadius: "20px", padding: "10px" }} ref={bg => bg && bg.style.setProperty("background", "#F47216", "important")} onClick={() => this.hojadevida(objeto.idsolicitud)}><MDBIcon icon="file-alt xs" /></button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody> 
                                </table>
                            </div>
                        </div>
                    </div>

                    {this.state.stateLoadign ? (
                        <Loading />
                    ) : (<React.Fragment></React.Fragment>)}
                </React.Fragment>
            </React.Fragment>
        );
    }
}

export default ReporteSolicitudVacantes;